module.exports = __webpack_public_path__ + "static/media/ebol_logo.c483125c.png";